import {Box, Menu, MenuItem} from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';

import React from "react";
import {
  ellipsisMenuProps,
  EllipsisRender
} from "src/components/common/Tables/Utilities/Ellipsis";
import {ISaasClientRestriction} from "../../../../services/SaasRestrictions/SaasRestrictionsQueries";

const menuItemStyling = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '13px',
}

interface theMenuProps extends ellipsisMenuProps {
  integration: ISaasClientRestriction,
  onUpdateClick: (integration: ISaasClientRestriction) => void,
  onSetStatusClick: (integration: ISaasClientRestriction) => void,
}

export const IntegrationsActionMenu = ({
  // General menu control
  anchorEl,
  open,
  handleClose: handleCloseActionMenu,

  // specific menu props
  integration,
  onUpdateClick,
  onSetStatusClick,
}: theMenuProps) => {

  const handleUpdateClick = () => {
    handleCloseActionMenu();
    setTimeout(() => onUpdateClick(integration), 0)
  }

  const handleSetStatusClick = () => {
    handleCloseActionMenu();
    setTimeout(() => onSetStatusClick(integration), 0)
  }

  const iconSize = '1.3rem';

  return (<>
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleCloseActionMenu}
    >
      <MenuItem onClick={handleUpdateClick}>
        <Box sx={menuItemStyling}>
          <TuneIcon sx={{fontSize: iconSize}}/>
          <div>
            {`Edit availability`}
          </div>
        </Box>
      </MenuItem>
      <MenuItem onClick={handleSetStatusClick}>
        <Box sx={menuItemStyling}>
          {integration.isDisabled ?
            <CheckCircleOutlineIcon sx={{fontSize: iconSize}}/> :
            <BlockIcon sx={{fontSize: iconSize}}/>}
          <div>
            {integration.isDisabled ? 'Enable' : 'Disable'}
          </div>
        </Box>
      </MenuItem>
    </Menu>
  </>);
};

// renderCell function for the Integrations panel
export const renderIntegrationEllipsis = ({
  integration,
  onUpdateClick,
  onSetStatusClick,
}: {
  integration: ISaasClientRestriction,
  onUpdateClick: (integration: ISaasClientRestriction) => void,
  onSetStatusClick: (integration: ISaasClientRestriction) => void,
}) => {
  return (
    <EllipsisRender
      menu={IntegrationsActionMenu}
      menuProps={{
        integration: integration,
        onUpdateClick: onUpdateClick,
        onSetStatusClick: onSetStatusClick,
      }}
    />
  );
};
